import { Route } from '@angular/router';
import { GuestGuard } from './core/guards/guest.guard';
import { LandingPageComponent } from './features/info/pages/landing-page/landing-page.component';
import { ContactUsComponent } from './features/info/pages/contact-us/contact-us.component';
import { FeesComponent } from './features/info/pages/fees/fees.component';
import { TermsComponent } from './features/info/pages/terms/terms.component';
import { PrivacyPolicyComponent } from './features/info/pages/privacy-policy/privacy-policy.component';
import { SignInComponent } from './features/auth/pages/sign-in/sign-in.component';
import { SignUpComponent } from './features/auth/pages/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './features/auth/pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './features/auth/pages/reset-password/reset-password.component';
import { AfterSignupComponent } from './features/auth/pages/after-signup/after-signup.component';
import { VerifyTfaComponent } from './features/auth/pages/verify-tfa/verify-tfa.component';
import { ProfileComponent } from './features/settings/pages/profile/profile.component';
import { PlansComponent } from './features/info/pages/prices/plans.component';
import { FaqComponent } from './features/info/pages/faq/faq.component';
import { AuthGuard } from './core/guards/auth.guard';
import { PageNotFoundComponent } from '@wm-libs/core';
import { environment } from '../environments/environment';

const staticPagesRoutes: Route[] = [
  { path: '', component: LandingPageComponent },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'support', component: ContactUsComponent },
  { path: 'fees', component: FeesComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'privacy', component: PrivacyPolicyComponent },
  { path: 'prices', component: PlansComponent },
  { path: 'faq', component: FaqComponent },
];

const authRoutes: Route[] = [
  { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
  { path: 'sign-in', component: SignInComponent },
  { path: 'sign-up', component: SignUpComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password/:code', component: ResetPasswordComponent },
  { path: 'after-signup', component: AfterSignupComponent },
  { path: 'account-activation/:activationCode', component: SignInComponent },
  { path: 'sign-up/confirm-invitation/:invitationCode', component: SignUpComponent },
  { path: 'verify-tfa', component: VerifyTfaComponent },
  { path: '**', redirectTo: 'sign-in' },
];

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => staticPagesRoutes,
  },
  {
    path: 'auth',
    loadChildren: () => authRoutes,
    canLoad: [GuestGuard],
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
    data: { app: 'wm-tech', env: environment },
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
    pathMatch: 'full',
  },
];
